import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useNavBarStore = defineStore('counter', () => {
  const drawerOpen = ref(false)
  const toggleDrawer = () => {
    drawerOpen.value = !drawerOpen.value
  }

  return { drawerOpen, toggleDrawer }
})
